<template>
  <div class="topRouge" id="reseauxTempo" v-if="detailReseauxTempoFilter.length">
    <p class="p_size18 has-text-weight-bold has-text-link bottomVert">
      <b-icon
        icon="circle"
        size="is-small"
        class="circleStyleMobile">
      </b-icon>
      Proposition réseau(x) temporaire(s)
    </p>
    <div class="colomn"
      v-for="(reseauxTempo, index) in detailReseauxTempoFilter"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxTempo.libelle}}
      </h3>
      <app-carte-reseaux-tempo :detailReseauxTempo="reseauxTempo"
       :markerReseauxTempo="markerReseauxTempo"/>
      <app-info-reseaux-tempo :infoReseauxTempo="reseauxTempo" :idOpportunite="idOpportunite"/>
    </div>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import carteReseauxTempo from './carteReseauxTempo';
import infoReseauxTempo from './infoReseauxTempo';

export default {
  name: 'index',
  props: ['detailReseauxTempo', 'adresseReseauxTempo', 'idOpportunite'],
  components: {
    appCarteReseauxTempo: carteReseauxTempo,
    appInfoReseauxTempo: infoReseauxTempo,
  },
  data() {
    return {
      markerReseauxTempo: {},
    };
  },
  computed: {
    detailReseauxTempoFilter() {
      return this.detailReseauxTempo.filter(d => !d.extensionOpportunite.reseauPersoGuid);
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseReseauxTempo.lat !== undefined) {
        this.markerReseauxTempo = {
          ...this.adresseReseauxTempo,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxTempo/index.vue